export default `
query (
  $location: LocationInput!,
  $categoryGuid: String!
) {
  searchFaqs(
    location: $location,
    categoryGuid: $categoryGuid
  ) {
    faqs {
      question
      answer
    }
  }
}
`;
